﻿/* Manos en Calma — CTA + planes + barra fija.
   Checkout real = botón de ReleasIt (#_rsi-buy-now-button / #rsi_buy_now_button). Los planes 1/2/3 son
   ofertas por cantidad de ReleasIt dentro de #_rsi-cod-form-modal (._rsi-quantity-offers-offer-container[data-offer-pos]). */
(function () {
  if (window.__mhInit) return;
  window.__mhInit = true;

  function visible(el) { var r = el && el.getBoundingClientRect(); return !!(r && r.width > 0 && r.height > 0); }

  function realButton() {
    var sels = ['.mh-hero #_rsi-buy-now-button-overwrite', '#rsi-button-hook #rsi_buy_now_button', '.mh-hero #_rsi-buy-now-button', '.product-form__buttons #_rsi-buy-now-button', '#_rsi-buy-now-button', '#rsi_buy_now_button'];
    for (var i = 0; i < sels.length; i++) {
      var list = [].slice.call(document.querySelectorAll(sels[i]));
      var v = list.filter(function (b) { return visible(b) && !b.closest('#_rsi-buy-now-button-floating'); })[0] || list.filter(visible)[0];
      if (v) return v;
    }
    return document.querySelector('form[action*="/cart/add"] button[type="submit"][name="add"]:not([disabled])');
  }

  function cards() { return [].slice.call(document.querySelectorAll('.mh-opt[data-pack]')); }
  var current = '2';

  function paint(pack) {
    current = String(pack);
    var card = null;
    cards().forEach(function (c) {
      var on = c.getAttribute('data-pack') === current;
      c.classList.toggle('on', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) card = c;
    });
    if (!card) return;
    var price = card.getAttribute('data-price') || '';
    var old = card.getAttribute('data-old') || '';
    var save = card.getAttribute('data-save') || '';
    [].forEach.call(document.querySelectorAll('[data-mh-price-now]'), function (e) { if (price) e.textContent = price; });
    [].forEach.call(document.querySelectorAll('[data-mh-price-old]'), function (e) { e.textContent = old; e.hidden = !old; });
    [].forEach.call(document.querySelectorAll('[data-mh-price-save]'), function (e) { e.textContent = save ? 'Ahorras ' + save : ''; e.hidden = !save; });
    var nm = card.querySelector('.t b');
    [].forEach.call(document.querySelectorAll('[data-mh-plan-name]'), function (e) { if (nm) e.textContent = nm.textContent; });
    [].forEach.call(document.querySelectorAll('[data-mh-sticky-now]'), function (e) { if (price) e.textContent = price; });
    [].forEach.call(document.querySelectorAll('[data-mh-sticky-old]'), function (e) { e.textContent = old; });
  }
  window.mhSelectPack = paint;

  var want = null, until = 0, obs = null, guard = false;
  function rowFor(pos) {
    var m = document.getElementById('_rsi-cod-form-modal');
    if (!m) return null;
    return m.querySelector('._rsi-quantity-offers-offer-container[data-offer-pos="' + pos + '"]') ||
      [].slice.call(m.querySelectorAll('._rsi-quantity-offers-offer-container'))[pos] || null;
  }
  function enforce() {
    if (want === null || Date.now() > until || guard) return;
    var row = rowFor(want);
    if (!row || row.classList.contains('_rsi-quantity-offers-selected')) return;
    guard = true;
    var inner = row.querySelector('._rsi-quantity-offers-offer') || row;
    inner.click();
    if (!row.classList.contains('_rsi-quantity-offers-selected')) row.click();
    setTimeout(function () { guard = false; }, 60);
  }
  function selectInForm(pack) {
    want = Number(pack) - 1;
    until = Date.now() + 4000;
    var m = document.getElementById('_rsi-cod-form-modal');
    if (m && !obs && window.MutationObserver) {
      obs = new MutationObserver(enforce);
      obs.observe(m, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    }
    (function poll() { enforce(); if (Date.now() < until) setTimeout(poll, 150); })();
  }
  document.addEventListener('click', function (ev) {
    if (ev.isTrusted && ev.target.closest && ev.target.closest('#_rsi-cod-form-modal ._rsi-quantity-offers-offer-container')) { want = null; }
  }, true);

  document.addEventListener('click', function (ev) {
    /* 1) El botón CTA siempre gana (aunque viva dentro de una tarjeta) */
    var t = ev.target.closest && ev.target.closest('[data-mh-cta]');
    if (t) {
      ev.preventDefault();
      var p = t.getAttribute('data-mh-pack');
      if (p) paint(p);
      var pack = p || current;
      var box = document.querySelector('[id^="MainProduct-"]');
      if (box) box.scrollIntoView({ behavior: 'instant', block: 'start' }); else window.scrollTo({ top: 0, behavior: 'instant' });
      setTimeout(function () {
        var b = realButton();
        if (b) { b.click(); selectInForm(pack); }
      }, 400);
      return;
    }
    /* 2) Clic directo en el botón real de ReleasIt del hero: abre con el plan elegido */
    var rb = ev.target.closest && ev.target.closest('.mh-hero #_rsi-buy-now-button-overwrite, .mh-hero #_rsi-buy-now-button, .mh-hero #rsi_buy_now_button');
    if (rb) { selectInForm(current); return; }
    /* 3) Tarjeta de plan del hero: solo selecciona */
    var opt = ev.target.closest && ev.target.closest('.mh-opt[data-pack]');
    if (opt) { ev.preventDefault(); paint(opt.getAttribute('data-pack')); }
  });

  function stickyCheck() {
    var st = document.querySelector('.mh-sticky');
    if (!st) return;
    var box = document.querySelector('[data-mh-buybox]');
    var end = document.querySelector('[data-mh-close]');
    var past = box ? box.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
    var inEnd = false;
    if (end) { var r = end.getBoundingClientRect(); inEnd = r.top < window.innerHeight && r.bottom > 0; }
    st.classList.toggle('show', past && !inEnd);
  }
  window.addEventListener('scroll', stickyCheck, { passive: true });

  /* ReleasIt pinta su boton con estilos propios (verde): se reestiliza al color de la landing */
  function skinButton() {
    [].forEach.call(document.querySelectorAll('.mh-hero ._rsi-buy-now-button'), function (b) {
      b.style.setProperty('background', '#7A4B2E', 'important');
      b.style.setProperty('background-color', '#7A4B2E', 'important');
      b.style.setProperty('color', '#FFF8F0', 'important');
      b.style.setProperty('border-radius', '999px', 'important');
      b.style.setProperty('border-color', '#7A4B2E', 'important');
      [].forEach.call(b.querySelectorAll('span,svg'), function (c) { c.style.setProperty('color', '#FFF8F0', 'important'); });
    });
  }
  var skinTries = 0;
  (function skinLoop() { skinButton(); if (skinTries++ < 20) setTimeout(skinLoop, 500); })();

  function init() {
    var root = document.querySelector('[data-mh-default]');
    paint(root ? root.getAttribute('data-mh-default') : '2');
    stickyCheck();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

